module.exports = __webpack_public_path__ + "img/Portrait_Smartphone.cefd2c92.jpg";